import React from 'react';
import { getChannelList } from 'api/channel';
import { Channel } from 'types/common';

let globalData:Channel[] = [];

const useChannel = ():[Channel[], boolean, ()=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<Channel[]>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getChannelList();
            if (!result.error) {
                const data:Channel[] = result?.data?.data || [];
                globalData = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!items || Object.keys(items).length === 0) {
            if (!loading) {
                fetchData();
            }
        }
    }, []);

    return [items, loading, fetchData];
};

export default useChannel;
